import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { alpha } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons';
import React, { FC } from 'react';

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.text.primary,
    fontSize: '20px',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 16,
  },
  subtitle: {
    color: theme.palette.text.primary,
    fontSize: '16px',
    marginBottom: 16,
  },
  containerBtns: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  cancelBtn: {},
  confirmBtn: {
    background: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      background: theme.palette.error.dark,
    },
    '&&.Mui-disabled': {
      background: alpha(theme.palette.error.main, 0.5),
      color: theme.palette.error.contrastText,
    },
  },
  iconGap: {
    marginRight: theme.spacing(1),
  },
  button: {
    textTransform: 'none',
  },
}));

interface ModalConfirmDeleteProps {
  handleClose: () => void;
  open: boolean;
  title: string;
  subtitle: string;
  textCancel: string;
  handleDelete: () => void;
  textConfirm: string;
  isLoading?: boolean;
}

const ModalConfirmDelete: FC<ModalConfirmDeleteProps> = ({
  handleClose,
  open,
  title,
  subtitle,
  textCancel,
  handleDelete,
  textConfirm,
  isLoading = false,
}) => {
  const classes = useStyles();

  const handleDialogClose = (event: React.SyntheticEvent, reason?: string) => {
    if (isLoading || reason === 'backdropClick') {
      return;
    }
    handleClose();
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown={isLoading}
    >
      <DialogContent>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.subtitle}>{subtitle}</Typography>
        <Box className={classes.containerBtns}>
          <Button
            className={`${classes.confirmBtn} ${classes.button}`}
            onClick={handleDelete}
            variant="contained"
            disableElevation
            disabled={isLoading}
            startIcon={isLoading ? <FontAwesomeIcon icon={faSpinner} spin /> : <FontAwesomeIcon icon={faTrash} size="sm" />}
          >
            {textConfirm}
          </Button>
          <Button
            className={`${classes.cancelBtn} ${classes.button}`}
            onClick={handleClose}
            variant="outlined"
            disableElevation
            disabled={isLoading}
            startIcon={<FontAwesomeIcon icon={faTimes} size="sm" />}
          >
            {textCancel}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalConfirmDelete;